import { SvgIcon } from '@avantia/style-guide';
import type { HpSvgIconTypes } from '@avantia/style-guide';
import classNames from 'classnames';
import './button.scss';

export type ButtonVariant = 'primary' | 'secondary' | 'reversed';

interface ButtonProps {
  text: string;
  type?: 'submit' | 'reset' | 'button';
  variant?: ButtonVariant;
  disabled?: boolean;
  handleClick?: () => void;
  className?: string;
  icon?: HpSvgIconTypes;
  id?: string;
  fullWidth?: boolean;
}

export const Button = ({
  text,
  type = 'button',
  variant = 'primary',
  handleClick,
  className,
  disabled = false,
  icon,
  id,
  fullWidth = false
}: ButtonProps): JSX.Element => {
  if (icon) {
    return (
      <button
        type={type}
        onClick={handleClick}
        className={classNames(className, `${variant}-icon-button`, { 'full-width': fullWidth })}
        disabled={disabled}
        id={id}>
        <SvgIcon type={icon} />
        <p className="icon-button-text">{text}</p>
      </button>
    );
  }

  return (
    <button
      type={type}
      onClick={handleClick}
      className={classNames(className, `${variant}-button`, { 'full-width': fullWidth })}
      disabled={disabled}
      id={id}>
      {variant === 'primary' || variant === 'reversed' ? <h3>{text}</h3> : <p>{text}</p>}
    </button>
  );
};
